import {
  FETCH_CURRENCY_RATES_FROM_URL_REQUEST,
  FETCH_CURRENCY_RATES_FROM_URL_SUCCESS,
  FETCH_CURRENCY_RATES_FROM_URL_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {
  isFetching: false,
};

export const currencyRates = createReducer(initialState, {
  [FETCH_CURRENCY_RATES_FROM_URL_REQUEST]: state => ({
    ...state,
    isFetching: true,
  }),

  [FETCH_CURRENCY_RATES_FROM_URL_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.date]: {
      ...(state[action.payload.date] || {}),
      ...action.payload.rates,
    },
    isFetching: false,
  }),

  [FETCH_CURRENCY_RATES_FROM_URL_FAILURE]: state => ({
    ...state,
    isFetching: false,
  }),
});

export default currencyRates;
